import React from 'react';
import { ProcessExpenseClaimProvider } from '../context/ProcessExpenseClaimProvider';
import { ExpenseClaimUtilProvider } from '../../context/ExpenseClaimUtilProvider';
import ProcessExpenseClaims from './ProcessExpenseClaims';

export default function EmployeeExpenseClaimsWrapper() {
  return (
    <ExpenseClaimUtilProvider>
      <ProcessExpenseClaimProvider>
        <ProcessExpenseClaims />
      </ProcessExpenseClaimProvider>
    </ExpenseClaimUtilProvider>
  );
}
